<template>
  <div class="discount-order-item">
    <div class="order-row">
      <div class="order-no">No. 202633939339 <van-icon name="records-o" /></div>
      <div class="order-state" :class="'state'+safeState">{{ safeState == 0 ? '待支付':safeState == 1 ? '已完成':'已作废' }}</div>
    </div>
    <div class="order-row">
      <div class="order-icon">
        <img src="https://img01.yzcdn.cn/vant/cat.jpeg" />
      </div>
      <div class="order-info">
        <ul>
            <li class="name">商品名称</li>
            <li class="price">捡漏价：<span class="red-txt">￥500.00</span></li>
            <li class="price">市场价：<span class="no-txt">￥10000.00</span></li>
            <li class="price" v-if="safeState != 2">预估利润：<span class="red-txt">￥500.00</span></li>
            <li class="time">捡漏时间：<span class="no-txt">08-04 12:46</span></li>
            <li v-if="safeState == 1">支付时间：<span class="no-txt">08-04 12:46</span></li>
            <li v-if="safeState == 0">剩余支付时间：<van-count-down :time="time" style="float: right;line-height: 26px;color: red;" /></li>
            
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DiscountOrderItemView',
  props:['state'],
  computed:{
    safeState(){
        return this.state || 0
    }
  },
  data(){
    return {
        time:100000
    }
  }
}
</script>
<style lang="scss" scoped>
.discount-order-item {
  margin: 10px;
  padding: 10px;
  border-bottom: 1px solid #7b8c9c;
  .order-row{
    display: flex;
    gap: 10px;
    position: relative;
    margin: 6px 0px;
    .order-no {
        font-size: 18px;
        font-weight: 600;
        flex: 1;
    }
    .order-state {
        position: absolute;
        color: #fff;
        top: -3px;
        right: 0px;
        font-size: 14px;
        padding: 4px 8px;
        border-radius: 8px;
    }
    .order-icon {
        flex: 1;
        img {
            width: 100%;
            border-radius: 10px;
        }
    }
    .order-info {
        flex: 2;
        li {
            line-height: 1.6;
        }
        .name {
            font-size: 18px;
            font-weight: 600;
        }
        .price {
            
        }
        .red-txt {
                color: red;
                font-weight: 600;
                float: right;
            }
            .no-txt {
                color: #7b8c9c;
                float: right;
            }
    }
    .state0 {
        background: red;
    }
    .state1 {
        background: green;
    }
    .state2 {
        background: #7b8c9c;
    }
  }
}
</style>
